export const publicAskedQuestionSelector = state =>
  state.pubAskedQuestion || '';

export const publicKeySelector = state => state.publicKey || '';

export const sentinelSelector = state => state.sentinel || '';
